module.exports = __webpack_public_path__ + "static/media/tw-ioc-rect.6c39546c.png";